import type { VuexOidcClientSettings } from 'vuex-oidc'

import type { ServicesConfig } from '../../models'
import { CONTAINER } from '../../config'
import { TYPES } from '../../config/inversify.types'

/*
TODO EMP-1351: here we should take care about subdomains, like we have in ephemerals
origin : root ( with port )
pathname: rest of url

Hash are not working with IAM, and also there is a problem with auth when you are not in the home
for example, you receive a link, and you click it, the route will be something like
https://host.com/empathy/search/insights/overall
we don't know how to manage if this route is the ephemeral o an internal route

we are now returning the origin to avoid problems but this doesn't work with ephemeral.
*/
function getRootPath(location: Location): string {
  return location.origin
}

export function getOidcSettings(): VuexOidcClientSettings {
  const { oidc } = CONTAINER.get<ServicesConfig>(TYPES.ServicesConfig)

  const baseUrl = getRootPath(window.location)
  const oidcSettings: VuexOidcClientSettings = {
    responseType: 'code',
    scope: 'openid profile',
    automaticSilentRenew: false,
    automaticSilentSignin: false,

    authority: oidc?.authority || 'unknown',
    client_id: oidc?.clientId || 'unknown',
    redirect_uri: `${baseUrl}/oidc-callback`,
    postLogoutRedirectUri: baseUrl,
  }

  return oidcSettings
}
